module.exports = __webpack_public_path__ + "img/boxed-13.99ba062c.jpg";